import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { hideMessage, showLoader } from "../../actions";

import IntlMessages from "../../utils/IntlMessages";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

class NotiModal extends Component {
  render() {
    const {
      showMessage,
      successMessage,
      alertMessage,
      infoMessage,
      warningMessage,
      hideMessage,
      modalClassName,
      modalTitle,
      modalHeaderName,
    } = this.props;
    return (
      <Modal isOpen={showMessage} className={modalClassName}>
        <ModalHeader className={modalHeaderName}>{modalTitle}</ModalHeader>
        <ModalBody style={{ flex: 1, wordWrap: "break-word" }}>
         {alertMessage && (<IntlMessages id={alertMessage}></IntlMessages>)} 

          {successMessage}
          {infoMessage}
          {warningMessage}
        </ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            onClick={() => {
              hideMessage();
            }}
          >
            Close
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

const mapStateToProps = ({ notify }) => {
  const {
    loader,
    alertMessage,
    successMessage,
    infoMessage,
    warningMessage,
    showMessage,
  } = notify;
  let modalClassName = "";
  let modalTitle = "";
  let modalHeaderName = "";
  if (alertMessage && alertMessage.length > 0) {
    modalClassName = "modal-danger";
    modalTitle = "Error";
    modalHeaderName = "bg-danger text-white";
  }
  if (successMessage && successMessage.length > 0) {
    modalClassName = "modal-success";
    modalTitle = "Success";
    modalHeaderName = "bg-success text-white";
  }
  if (infoMessage && infoMessage.length > 0) {
    modalClassName = "modal-info";
    modalTitle = "Info";
    modalHeaderName = "bg-info text-white";
  }
  if (warningMessage && warningMessage.length > 0) {
    modalClassName = "modal-warning";
    modalTitle = "Warning";
    modalHeaderName = "bg-Warning text-white";
  }
  return {
    loader,
    alertMessage,
    successMessage,
    infoMessage,
    warningMessage,
    showMessage,
    modalClassName,
    modalTitle,
    modalHeaderName,
  };
};

export default withRouter(
  connect(mapStateToProps, {
    hideMessage,
    showLoader,
  })(NotiModal)
);
